import { styled } from 'css-literal-loader/styled';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import bundleDesktopIndividual from '../assets/desktop/bundle-individual.png';
import bundleDesktopTeam from '../assets/desktop/bundle-team.png';
import bundleMobileIndividual from '../assets/mobile/bundle-individual.png';
import bundleMobileTeam from '../assets/mobile/bundle-team.png';
import withReservation from '../utils/Reservation';
import BreadCrumbs from './BreadCrumbs';
import Card from './Card';
import { CardCol, CardRow, CardTop } from './CrossSegmentCard';
import Heading from './Heading';
import PageSegment from './PageSegment';
import Responsive from './Responsive';
import Small from './Small';

const HeaderImage = styled('img', null, "HeaderImage", require("./BundleHeaderPageSegment-HeaderImage.module.scss"), "header-image", "headerImage");

const CenteredCol = styled(CardCol, null, "CenteredCol", require("./BundleHeaderPageSegment-CenteredCol.module.scss"), "centered-col", "centeredCol");

const BundleHeading = styled(Heading, null, "BundleHeading", require("./BundleHeaderPageSegment-BundleHeading.module.scss"), "bundle-heading", "bundleHeading");

const BundleSubtitle = styled(Small, null, "BundleSubtitle", require("./BundleHeaderPageSegment-BundleSubtitle.module.scss"), "bundle-subtitle", "bundleSubtitle");
const propTypes = {};

/**
 * This card is split into two cards to handle aligning against the background
 * more easily. Its hidden to screen-readers to avoid weird document flow.
 */
function BundleHeaderPageSegment({ cart }) {
  const { teamBaseNumCloudUsers } = cart.remote.inventory;
  return (
    <PageSegment theme="dark" align="center">
      <BreadCrumbs active="bundle" />
      <PageSegment.Heading>
        <FormattedMessage
          id="bundle.heading"
          defaultMessage="Select your bundle."
        />
      </PageSegment.Heading>
      <Responsive smDown aria-hidden>
        {isSmall => (
          <CardTop direction="row">
            <Card.Segment grow noBorder direction="column">
              <CardRow>
                <CenteredCol as={BundleHeading} aria-hidden level="2">
                  <FormattedMessage
                    defaultMessage="Individual"
                    id="bundle.individual.heading"
                  />
                </CenteredCol>
                <CenteredCol as={BundleHeading} aria-hidden level="2">
                  <FormattedMessage
                    defaultMessage="Team"
                    id="bundle.team.heading"
                  />
                </CenteredCol>
              </CardRow>

              <CardRow>
                <CenteredCol as={BundleSubtitle}>
                  <FormattedMessage
                    defaultMessage="Ultrasound for you.{br}1 probe, 1 user license"
                    id="bundle.individual.subtitle"
                    values={{ br: <br /> }}
                  />
                </CenteredCol>
                <CenteredCol as={BundleSubtitle}>
                  <FormattedMessage
                    defaultMessage="Ultrasound for teams.{br}Multiple probes, {teamBaseNumCloudUsers}+ user licenses."
                    id="bundle.individual.subtitle"
                    values={{ br: <br />, teamBaseNumCloudUsers }}
                  />
                </CenteredCol>
              </CardRow>
              <CardRow>
                <CenteredCol>
                  <HeaderImage
                    src={
                      isSmall
                        ? bundleMobileIndividual
                        : bundleDesktopIndividual
                    }
                    alt=""
                    aria-hidden
                  />
                </CenteredCol>
                <CenteredCol>
                  <HeaderImage
                    src={isSmall ? bundleMobileTeam : bundleDesktopTeam}
                    alt=""
                    aria-hidden
                  />
                </CenteredCol>
              </CardRow>
            </Card.Segment>
          </CardTop>
        )}
      </Responsive>
    </PageSegment>
  );
}

BundleHeaderPageSegment.propTypes = propTypes;

export default withReservation(BundleHeaderPageSegment);
